import environment from 'platform/utilities/environment';
import {
  fileInputSchema,
  fileInputUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VA_FORM_IDS } from 'platform/forms/constants';
import {
  API_ENDPOINTS,
  FILE_SIZE_MAX_BYTES,
  FILE_TYPES_ACCEPTED,
} from '../utils/constants';

export const FILE_UPLOAD_URL = `${environment.API_URL}${API_ENDPOINTS.fileUpload}`;

/**
 * Builds a configured fileInputUI component for submitting a supporting document.
 *
 * @param {Object} [options={}] - Configuration options.
 * @param {boolean} [options.required=true] - Optional flag for marking the field as required.
 * @param {string} [options.title] - Input label displayed for the file field.
 * @returns {Object} A `fileUploadUI` configuration object.
 */
export const attachmentUI = ({ required = true, title }) => {
  const createPayload = (file, _formId, password = null) => {
    const payload = new FormData();
    payload.append('hca_attachment[file_data]', file);
    if (password) {
      payload.append('hca_attachment[password]', password);
    }
    return payload;
  };

  const parseResponse = ({ data }, file) => ({
    confirmationCode: data.attributes.guid,
    file,
  });

  return fileInputUI({
    accept: FILE_TYPES_ACCEPTED,
    fileUploadUrl: FILE_UPLOAD_URL,
    formNumber: VA_FORM_IDS.FORM_10_10EZ,
    maxFileSize: FILE_SIZE_MAX_BYTES,
    minFileSize: 1,
    createPayload,
    parseResponse,
    required,
    title,
  });
};

export const attachmentSchema = fileInputSchema();
